import { createSlice } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import {
  systemStatsThunk,
  getAbhaCardThunk,
  getAbhaCardPhrThunk,
} from "./thunk";

const getAbhaCardInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const getAbhaCardSlice = createSlice({
  name: "getAbhaCard",
  initialState: getAbhaCardInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAbhaCardThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getAbhaCardThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(getAbhaCardThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const getAbhaCardPhrInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const getAbhaCardPhrSlice = createSlice({
  name: "getAbhaCardPhr",
  initialState: getAbhaCardPhrInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAbhaCardPhrThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getAbhaCardPhrThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(getAbhaCardPhrThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

export const { reset: resetGetAbhaCard } = getAbhaCardSlice.actions;
export const { reset: resetGetAbhaCardPhr } = getAbhaCardPhrSlice.actions;

const reducers = combineReducers({
  getAbhaCard: getAbhaCardSlice.reducer,
  getAbhaCardPhr: getAbhaCardPhrSlice.reducer,
});

export default reducers;
